import SubdirectoryArrowRightRoundedIcon from "@mui/icons-material/SubdirectoryArrowRightRounded";
import { Box, Stack } from "@mui/material";
import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";
import LinkIcon from "@entrilia/shared/icons/LinkIcon.tsx";
import type { ShowFieldOptionsSettings } from "../Types.ts";
import ConditionMarker from "../conditions/ConditionMarker.tsx";
import { formatCaption } from "../conditions/conditionsHelper.tsx";
import AreaFieldItem from "../fields/area-fields/AreaFieldItem.tsx";

interface Props {
  conditions: ConditionField[];
  canBeRemoved: boolean;
  disableEqualitySelection?: boolean;
  onRemoveItem: (item: ConditionField) => void;
  onShowOptions?: (settings: ShowFieldOptionsSettings<ConditionField>) => void;
  onSetAutoShowItemOptionsId: ((id?: string) => void) | undefined;
  autoShowItemOptionsId?: string;
  readonly: boolean;
}

export const MeasureItemConditions = ({
  conditions,
  canBeRemoved,
  onRemoveItem,
  onShowOptions,
  disableEqualitySelection,
  autoShowItemOptionsId,
  onSetAutoShowItemOptionsId,
  readonly,
}: Props) => {
  return (
    <Stack className="field-condition-list" sx={{ py: 0.5, gap: 0.5 }}>
      {conditions.map((field) => {
        const isLinked = field.linked === true;
        return (
          <Stack
            key={field.config.guid}
            className="field-condition-row"
            direction="row"
            sx={(t) => ({
              alignItems: "center",
              pl: 1,
              pr: 0.5,
              gap: 0.5,
              position: "relative",
              backgroundColor: readonly ? t.palette.action.disabledBackground : "transparent",
            })}
          >
            {field.config.parameter && canBeRemoved && <ConditionMarker />}
            <Stack sx={{ width: 20, flexShrink: 0, alignItems: "center" }}>
              {isLinked ? <LinkIcon /> : <SubdirectoryArrowRightRoundedIcon color="primary" />}
            </Stack>
            <Box sx={{ display: "flex", flex: 1, minWidth: 0, border: 1, borderColor: "divider" }}>
              <AreaFieldItem
                field={field}
                canBeRemoved={canBeRemoved && !readonly}
                hideOptions={isLinked}
                removeButtonLabel={isLinked ? "Unlink condition" : "Remove condition"}
                onRemoveItem={onRemoveItem}
                onShowOptions={isLinked ? undefined : onShowOptions}
                formatCaption={formatCaption}
                disableEqualitySelection={disableEqualitySelection}
                autoShowItemOptionsId={autoShowItemOptionsId}
                onSetAutoShowItemOptionsId={onSetAutoShowItemOptionsId}
                readonly={readonly}
              />
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
};
export default MeasureItemConditions;
